export default __webpack_public_path__ + "static/media/five_9.3f1efef8.png";